var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.success)?_c('div',{staticClass:"pa-2"},[_vm._v("\n    The requested file couldn't not be found.\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }